export const marketCategory = [
  '기획전/추천', '지역농산품', 'MD추천상품', '지금할인중이에요'
];
